export default "__VITE_ASSET__Cwx8gbTz__"